import {Inject, Injectable} from '@angular/core';
import {Observable, ReplaySubject, Subject} from 'rxjs';
import {CountedAndPaginated} from '../interface/response/counted-and-paginated';
import {ListResponse} from '../interface/response/list-response';
import {HttpClient} from '@angular/common/http';
import {FilterService} from './filter.service';
import {DOCUMENT} from '@angular/common';
import {first, take} from 'rxjs/operators';
import {Uuid} from '../interface/response/uuid';
import {Invoice} from '../interface/invoice';
import {Contract} from "../interface/contract";

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  public readonly invoiceListSubject: ReplaySubject<CountedAndPaginated<Invoice>> = new ReplaySubject<CountedAndPaginated<Invoice>>(1);
  public readonly invoiceNotCountedListSubject: ReplaySubject<ListResponse<Invoice>> = new ReplaySubject<ListResponse<Invoice>>(1);
  public  numberOfInvoicesOnHold = 0;
  public numberOfInvoicesToBeProcessed = 0;

  constructor(
    private httpClient: HttpClient,
    private filterService: FilterService,
    @Inject(DOCUMENT) private document: Document,
  ) {
  }

  public generatePayment(filters: object): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/payment/generate?` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }
  public loadPaymentList(
    page: number,
    pageSize: number,
    filters: object,
    sort?: {
      sortBy?: string,
      sortOrder?: string,
    }
  ): void {
    this.httpClient.get(`/rest/crm/invoice?page=${page + 1}&pageSize=${pageSize}&sortBy=${sort.sortBy ?? ''}&sortOrder=${sort.sortOrder ?? ''}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Invoice>) => {
          this.invoiceListSubject.next(result);
      });
  }

  public loadPaymentNumberOfInvoices(
    page: number,
    pageSize: number,
    filters: object,
    filtersv2: object,
  ): any {
    this.httpClient.get(`/rest/crm/invoice?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filters))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Invoice>) => {
        this.numberOfInvoicesToBeProcessed = result.pagination.total;
      });
    this.httpClient.get(`/rest/crm/invoice?page=${page + 1}&pageSize=${pageSize}&` + this.filterService.parseFilters(filtersv2))
      .pipe(
        first()
      )
      .subscribe((result: CountedAndPaginated<Invoice>) => {
        this.numberOfInvoicesOnHold = result.pagination.total;
      });
  }
  public getNumberOfInvoicesToBeProcessed(): number {
    return this.numberOfInvoicesToBeProcessed;
  }

  public getNumberOfInvoicesOnHold(): number {
    return this.numberOfInvoicesOnHold;
  }

  public getPaymentListSubject(): ReplaySubject<CountedAndPaginated<Invoice>> {
    return this.invoiceListSubject;
  }
  public downloadPaymentList(filters: object, sort?: { sortBy?: string, sortOrder?: string }): Observable<Uuid> {
    return this.httpClient.post(`/rest/crm/payment-invoice-list?&sortBy=${sort.sortBy ?? ''}&sortOrder=${sort.sortOrder ?? ''}&` + this.filterService.parseFilters(filters), {})
      .pipe(first()) as Observable<Uuid>;
  }
}
